export default __webpack_public_path__ + "assets/models/83c03e1582894d12fea483cb728a2a0a.glb";